// Override labels applied ONLY in the side hamburger menus (mobile + desktop).
// The canonical catalogueStructure.js stays untouched, so the catalog page,
// header dropdown and Hero panel keep the short labels.
export const HAMBURGER_SUB_LABELS = {
  'petit-barnum': 'Petit BARNUM - 18 à 40 assis',
  'moyen-barnum': 'Moyen BARNUM - 48 à 84 assis',
  'grand-barnum': 'Grand BARNUM - 96 à 120 assis',
  'geant-barnum': 'Géant BARNUM - 128 à 156 assis',
  'tentes-pliantes': 'TENTES PLIANTES',
  'parquets': 'PLANCHER DE RECEPTION',
};

export function labelForHamburger(sub) {
  return HAMBURGER_SUB_LABELS[sub.slug] || sub.name;
}
